<template>
  <div id="container">
    <section>
      <div v-for="(assignment, a) in assignments" style="border: 1px solid black; padding: 5px">
        <details>
          <summary>Assignment#{{a+1}}</summary>
          <hr />
          <section>
            <!-- <video src="../assets/Assignment_1.mp4" width="80%" height="80%" controls></video> -->
            <video v-if="movieAssetsLoaded[a]" width="80%" height="80%" controls>
              <source :src="videoName(a+1)" type="video/mp4" />
            </video>
            <div v-for="(sentence, s) in assignment" id="sentence">
              <div
                :data-assignment_id="a"
                :data-sentence_id="s"
                data-language_id="english"
                @click="sentenceClick(sentence, $event)"
                class="englishSentence"
              >{{getSentence(a, s, "english")}}</div>
              <div class="translate">
                <button
                  :data-assignment_id="a"
                  :data-sentence_id="s"
                  data-language_id="english"
                  @click="translateSentenceToFrench($event)"
                >>></button>
              </div>
              <div
                :data-assignment_id="a"
                :data-sentence_id="s"
                data-language_id="french"
                @click="sentenceClick(sentence, $event)"
                class="frenchSentence"
              >{{getSentence(a, s, "french")}}</div>
            </div>
          </section>
        </details>
      </div>
    </section>
    <!-- <section id="input">
      <input ref="input" @keyup.enter="editingEnter" v-model="editSentence" :size="80" />
    </section>
    <section id="buttons">
      <button @click="storeAssignments">Store Assignments</button>
      <button @click="loadAssignments">Load Assignments</button>
    </section>-->
  </div>
</template>

<script>
import { assignments, methods } from "../stores/SentenceStore";

let compObject = {
  name: "Assignment",
  components: {
    //Assignment
  },
  data: function() {
    return {
      sentence_id: 0,
      assignment_id: 0,
      language_id: "english", // OPTIONS: "english" and "french"
      assignments,
      editSentence: "",
      editFrenchSentence: "",

      // Voice constants
      englishVoiceParameter: "en-US", // "en-US" and "fr" -- default is "en-US"
      frenchVoiceParameter: "fr",
      englishSpeakRate: 0.6,
      frenchSpeakRate: 0.6,
      speechRate: 0.7,

      // Data structure constants
      englishParameter: "english",
      frenchParameter: "french",

      movieAssetsLoaded: new Array(10).fill(true)
    };
  },
  computed: {},
  methods: {
    videoName(count) {
      try {
        this.movieAssetsLoaded[count - 1] = true;
        return require("@/assets/Assignment_" + count + ".mp4");
      } catch (error) {
        this.movieAssetsLoaded[count - 1] = false;
        return "";
      }
    },
    // ====== STORAGE ==============//

    storeAssignments() {
      this._store();
    },
    loadAssignments() {
      let loadedAssignments = this._load();
      this.assignments = loadedAssignments;
      this.$forceUpdate(); // Do we need this?
      this.editSentence = this.currentEnglishSentence();
    },

    // ====== UI Click / EVENTS ==============//

    sentenceClick(sentence, event) {
      this.sentence_id = sentence.sentence_id;
      this.assignment_id = sentence.assignment_id;
      this.language_id = event.currentTarget.dataset.language_id;

      let highlightedText = document.getSelection().toString();

      // Set input form value
      this.editSentence = this.getCurrentSentence();

      if (highlightedText <= 0) this.speak(this.getCurrentSentence());
      else {
        this.speak(highlightedText);
        // this.$refs.input.focus();
      }
    },

    editingEnter() {
      this.setSentence({
        sentence: this.editSentence,
        assignment_id: this.assignment_id,
        sentence_id: this.sentence_id,
        language_id: this.language_id
      });
      this.nextSentenceForward();
      this.editSentence = this.getCurrentSentence();
    },

    // ====== MODEL Access ==============//
    nextSentenceBackward() {
      if (this.sentence_id <= 0) {
        this.sentence_id;
      } else {
        this.sentence_id -= 1;
      }
    },
    nextSentenceForward() {
      if (this.sentence_id >= this._getSentenceCount(this.assignment_id) - 1) {
        this.sentence_id;
      } else {
        this.sentence_id += 1;
      }
    },
    incAssignmentCount() {
      this.assignment_id >= this._getAssignmentCount(this.assignment_id) - 1
        ? this.assignment_id
        : ((this.assignment_id += 1), (this.sentence_id = 0));
    },
    decAssignmentCount() {
      if (this.assignment_id <= 0) {
        this.assignment_id;
      } else {
        this.assignment_id -= 1;
        this.sentence_id = 0;
      }
    },
    getSentence(assignment_id, sentence_id, language_id) {
      return this.assignments[assignment_id][sentence_id][language_id];
    },
    setSentence({ sentence, assignment_id, sentence_id, language_id }) {
      if (language_id == this.frenchParameter)
        return (this.assignments[this.assignment_id][
          this.sentence_id
        ].french = sentence);
      else
        return (this.assignments[this.assignment_id][
          this.sentence_id
        ].english = sentence);
    },
    getCurrentSentence() {
      return this.assignments[this.assignment_id][this.sentence_id][
        this.language_id
      ];
    },
    englishSentence() {
      return this.assignments[this.assignment_id][this.sentence_id].english;
    },
    setEnglishSentence(sentence) {
      return (this.assignments[this.assignment_id][
        this.sentence_id
      ].english = sentence);
    },
    setFrenchSentence(sentence) {
      this.assignments[this.assignment_id][this.sentence_id].french = sentence;
    },

    // *************  Translate ***********************
    translateSentenceToFrench(event) {
      this.assignment_id = event.currentTarget.dataset.assignment_id;
      this.sentence_id = event.currentTarget.dataset.sentence_id;
      this.language_id = event.currentTarget.dataset.language_id;
      this.setFrenchSentence(
        this.translateToFrench(
          this.getSentence(this.language_id, this.sentence_id, language_id)
        )
      );
    },
    translateToFrench(englishSentence) {
      return `${englishSentence} => Bah, bah, bah`;
    },

    // ****************  Voice ***********************

    speak(text = "", rate = this.englishSpeakRate) {
      let lang = this.englishVoiceParameter;
      if (this.language_id == this.frenchParameter) {
        lang = this.frenchVoiceParameter;
        rate = this.frenchSpeakRate;
      }
      let u = new SpeechSynthesisUtterance();
      u.text = text;
      u.lang = lang;
      u.rate = rate;
      speechSynthesis.speak(u);
    }
  },
  computed: {
    assignmentsCount() {
      return this.assignments.length;
    },
    sentences() {
      return this.assignments[this.assignment_id][this.sentence_id];
    }
  },
  mounted: function() {
    this.editSentence = this.englishSentence();
    // this.$nextTick(function() {
    //   Code that will run only after the
    //   entire view has been rendered
    //   this.editSentence = this.englishSentence();
    //   this.editSentence = this.assignments[this.assignment_id][
    //     this.sentence_id
    //   ].english;
    // });
  }
};

compObject.methods = { ...compObject.methods, ...methods };

export default compObject;
</script>

<style scoped>
details {
}

section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

summary {
  text-align: center;
  padding: 5px;
  outline: none;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  width: 100vw;
}

#container {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 15px;
  justify-items: center;
  align-items: center;
  width: 100%;
}

#sentence {
  display: grid;
  grid-template-columns: 1fr 50px 1fr;
  align-items: center;
  min-width: 50vw;
}

.englishSentence:hover {
  border: 2px solid black;
  /* background-color: lightsteelblue; */
}

.translate {
  /* background-color: lightgray; */
}

button {
  margin: 5px;
  padding: 5px;
}

details {
  min-width: 400px;
}

summary {
  width: 100%;
}
</style>
